import {gql} from 'apollo-boost';

export const removeCategoryMutation = gql`
    mutation removeCategory($id: Int!) {
        removeCategory(id: $id)
    }
`;
